(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentDeleteController',TkbPaymentDeleteController);

    TkbPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TkbPayment'];

    function TkbPaymentDeleteController($uibModalInstance, entity, TkbPayment) {
        var vm = this;

        vm.tkbPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TkbPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
